/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Rmf_Banner_StartingInputs */

const en_rmf_banner_starting = /** @type {(inputs: Rmf_Banner_StartingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`stack startup (${i?.seconds}s)`)
};

const fr_rmf_banner_starting = /** @type {(inputs: Rmf_Banner_StartingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`démarrage de la stack (${i?.seconds}s)`)
};

const ms_sg2_rmf_banner_starting = /** @type {(inputs: Rmf_Banner_StartingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`permulaan stack (${i?.seconds}s)`)
};

/**
* | output |
* | --- |
* | "stack startup ({seconds}s)" |
*
* @param {Rmf_Banner_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_banner_starting = /** @type {((inputs: Rmf_Banner_StartingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Banner_StartingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_banner_starting(inputs)
	if (locale === "fr") return fr_rmf_banner_starting(inputs)
	return ms_sg2_rmf_banner_starting(inputs)
});